import React, {useState, useEffect, useRef} from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function TeamCaroussel(props) {

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

  const arrowStyleLeft = {
    color: "#D65A31",
    background: "transparent",
    left: 0,
    position: "absolute",
    outline: 0,
    transition: "all .5s",
    borderRadius: "35px",
    zIndex: "1000",
    border: "0",
    minWidth: "43px",
    minHeight: "43px",
    opacity: "1",
    cursor: "pointer"
  };

  const arrowStyleRight = {
    color: "#D65A31",
    background: "transparent",
    right: 0,
    transform: "translateX(20%)",
    position: "absolute",
    outline: 0,
    transition: "all .5s",
    borderRadius: "35px",
    zIndex: "1000",
    border: "0",
    minWidth: "43px",
    minHeight: "43px",
    opacity: "1",
    cursor: "pointer"
  };

  const CustomRight = ({ onClick }) => (
    <button className="arrow right" onClick={onClick} style={arrowStyleRight}>
      <ArrowForwardIosIcon   style={{ fontSize: "50px" }} />
    </button>
  );
  const CustomLeft = ({ onClick }) => (
    <button className="arrow left" onClick={onClick} style={arrowStyleLeft}>
      <ArrowBackIosIcon   style={{ fontSize: "50px" }} />
    </button>
  );
  
    return (
      <Carousel
    swipeable={false}
    draggable={true}
    showDots={true}
  responsive={responsive}
  ssr={true} // means to render carousel on server-side.
  infinite={true}
  autoPlay={ "mobile" ? true : false}
  autoPlaySpeed={1000}
  keyBoardControl={true}
  customTransition="all 2"
  transitionDuration={2000}
  containerClass="carousel-container"
  //removeArrowOnDeviceType={["tablet", "mobile"]}
  //deviceType={this.props.deviceType}
  dotListClass="custom-dot-list-style"
  //itemClass="carousel-item-padding-40-px"
  //customRightArrow={<CustomRight />}
  customLeftArrow={<CustomLeft />}
  customRightArrow={<CustomRight />}
>
  <div className="card">
    <div className="card__img_container">
      <img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1690647398/team-removebg-preview_1_ifgpdk.png" alt="" />
    </div>
    <h3>Youssef Addadi</h3>
    <h4>Job Title</h4>
  </div>
  <div className="card">
    <div className="card__img_container">
      <img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1690647398/team-removebg-preview_1_ifgpdk.png" alt="" />
    </div>
    <h3>John Doe</h3>
    <h4>Job Title</h4>
  </div>
  <div className="card">
    <div className="card__img_container">
      <img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1690647398/team-removebg-preview_1_ifgpdk.png" alt="" />
    </div>
    <h3>Max Field</h3>
    <h4>Job Title</h4>
  </div>
  <div className="card">
    <div className="card__img_container">
      <img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1690647398/team-removebg-preview_1_ifgpdk.png" alt="" />
    </div>
    <h3>Rose Schneider</h3>
    <h4>Job Title</h4>
  </div>
  <div className="card">
    <div className="card__img_container">
      <img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1690647398/team-removebg-preview_1_ifgpdk.png" alt="" />
    </div>
    <h3>Youssef Addadi</h3>
    <h4>Job Title</h4>
  </div>
</Carousel>)
}

export default TeamCaroussel